export const toolsSuppliesLevelTwo = [
    {
        "parentCategoryId": "tools_n_supplies",
        "level": 2,
        "name": "Beading Tools",
        "categoryId": "beading_tools"
    },
    {
        "parentCategoryId": "tools_n_supplies",
        "level": 2,
        "name": "Bag Making Accessories",
        "categoryId": "bag_making_accessories"
    }

]
